/* ============================================================================
 * Project        : Deloitte Digital Compliance
 * File           : validationConsole.jsx
 * Version        : 1.0.0
 * Author         : Team Neubinary
 * Created On     : 2026-06-24
 *
 * Description    : Digital Compliance for Automation and Governance
 *
 * Change History :
 * ----------------------------------------------------------------------------
 * Date         | Version | Author           | Description
 * ----------------------------------------------------------------------------
 * 2026-06-24   | 1.0.0   | Team Neubinary   | Initial creation
 * <YYYY-MM-DD> | x.x.x   | <Name/Team>      | <Change description>
 * ============================================================================
 *
 * Copyright (c) 2026 AU79 Consulting Services Pvt. Ltd.
 * All Rights Reserved.
 *
 * This source code and its contents are confidential and proprietary to
 * AU79 Consulting Services Pvt. Ltd. Unauthorized copying, reproduction,
 * modification, distribution, or disclosure of this material, in whole or
 * in part, is strictly prohibited without prior written permission from
 * AU79 Consulting Services Pvt. Ltd.
 * ============================================================================
 */
import { Box, Typography, IconButton, Divider } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";

export default function ValidationConsole({
  open,
  errors,
  onClose,
  onSelectIssue,
}) {
  if (!open) return null;

  return (
    <Box
      role="region"
      aria-label="Workflow validation console"
      sx={{
        position: "absolute",
        bottom: 0,
        left: 0,
        right: 0,
        height: 220,
        backgroundColor: "#121212",
        color: "#fff",
        borderTop: "1px solid #333",
        zIndex: 20,
        display: "flex",
        flexDirection: "column",
      }}
    >
      {/* Header */}
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          px: 2,
          py: 1,
        }}
      >
        <Typography fontWeight={600} flex={1}>
          Validation Errors ({errors.length})
        </Typography>
        <IconButton
          size="small"
          onClick={onClose}
          aria-label="Close validation console"
        >
          <CloseIcon sx={{ color: "#fff" }} />
        </IconButton>
      </Box>

      <Divider sx={{ borderColor: "#333" }} />

      {/* Error list */}
      <Box
        sx={{
          flex: 1,
          overflowY: "auto",
        }}
      >
        {errors.map((err, i) => (
          <Box
            key={i}
            role="button"
            tabIndex={0}
            onClick={() => onSelectIssue(err)}
            onKeyDown={(e) => e.key === "Enter" && onSelectIssue(err)}
            sx={{
              px: 2,
              py: 1.5,
              cursor: "pointer",
              display: "flex",
              gap: 1,
              alignItems: "flex-start",
              "&:hover": { backgroundColor: "#1e1e1e" },
              "&:focus": {
                outline: "2px solid #90caf9",
              },
            }}
          >
            <ErrorOutlineIcon
              fontSize="small"
              sx={{ color: "#f44336", mt: "2px" }}
            />
            <Typography variant="body2">{err.message}</Typography>
          </Box>
        ))}
      </Box>
    </Box>
  );
}
